<div class="flex flex-col gap-4">
  <div class="flex items-end gap-2">
    <driver-autocomplete class="w-4/12" (driverChange)="onMotoristaChange($event)" />
    <mat-form-field class="input-tg w-3/12" appearance="outline">
      <mat-label>Data</mat-label>
      <input matInput [matDatepicker]="dataPicker" [(ngModel)]="data" />
      <mat-datepicker-toggle matIconSuffix [for]="dataPicker"></mat-datepicker-toggle>
      <mat-datepicker #dataPicker></mat-datepicker>
    </mat-form-field>
    <div class="flex items-center mb-4 gap-2">
      <button class="btn-icon" [disabled]="!podeConsultar || loading" (click)="consultar()" [matTooltip]="'Consultar'">
        <mat-icon>search</mat-icon>
      </button>
      <button mat-flat-button class="btn-tg" [disabled]="!podeConsultar || baixandoExcel" (click)="baixarExcel()">
        @if (baixandoExcel) {
        <mat-spinner diameter="20" class="loading-spinner"></mat-spinner>
        } @else {
        Excel
        }
      </button>
      <button mat-flat-button class="btn-tg" [disabled]="!podeConsultar || baixandoPdf" (click)="baixarPdf()"
        [matTooltip]="'A folha que vai para o motorista (paisagem, A4)'">
        @if (baixandoPdf) {
        <mat-spinner diameter="20" class="loading-spinner"></mat-spinner>
        } @else {
        PDF
        }
      </button>
    </div>
  </div>

  @if (loading) {
  <mat-progress-bar mode="indeterminate"></mat-progress-bar>
  }

  @if (!loading && buscou && cronograma) {
  <div class="flex justify-between items-start border rounded p-3">
    <div>
      <div class="font-semibold">{{ cronograma.motoristaNome }} — {{ cronograma.data }}</div>
      @if (cronograma.empresaNome) {
      <div class="text-sm text-gray-600">
        {{ cronograma.empresaNome }}@if (cronograma.empresaCnpj) { · CNPJ {{ cronograma.empresaCnpj }} }
      </div>
      }
    </div>
    <div class="text-sm text-gray-600">Total de serviços: <b>{{ cronograma.totalServicos }}</b></div>
  </div>

  @if (cronograma.servicos.length === 0) {
  <div class="text-center text-gray-500 py-6">Motorista livre nesse dia — sem serviço escalado.</div>
  } @else {
  <div class="tab-overflow">
    <table mat-table [dataSource]="cronograma.servicos" class="mat-elevation-z8 w-full">
      <ng-container matColumnDef="servico">
        <th mat-header-cell *matHeaderCellDef>Serviço</th>
        <td mat-cell *matCellDef="let item" [class.cancelado]="cancelado(item)">
          <b>OS: </b>{{ item.codigoOs }}<br />
          <b>TG: </b>{{ item.servico || '-' }}<br />
          <b>Cliente: </b>{{ item.agencia || '-' }}
          @if (item.cliente) {
          <br /><b>Subcliente: </b>{{ item.cliente }}
          }
        </td>
      </ng-container>

      <ng-container matColumnDef="horario">
        <th mat-header-cell *matHeaderCellDef>Data / Horário</th>
        <td mat-cell *matCellDef="let item" [class.cancelado]="cancelado(item)">
          {{ item.data }}<br />{{ item.horario || '-' }}
        </td>
      </ng-container>

      <ng-container matColumnDef="tipoServico">
        <th mat-header-cell *matHeaderCellDef>Tipo</th>
        <td mat-cell *matCellDef="let item" [class.cancelado]="cancelado(item)">{{ item.tipoServico || '-' }}</td>
      </ng-container>

      <ng-container matColumnDef="percurso">
        <th mat-header-cell *matHeaderCellDef>Percurso</th>
        <td mat-cell *matCellDef="let item" [class.cancelado]="cancelado(item)">
          <b>Apresentação: </b>{{ item.enderecoApresentacao || '-' }}<br />
          <b>Desembarque: </b>{{ item.enderecoDesembarque || '-' }}
          @if (item.observacao) {
          <br /><b>Obs.: </b>{{ item.observacao }}
          }
        </td>
      </ng-container>

      <ng-container matColumnDef="passageiros">
        <th mat-header-cell *matHeaderCellDef>Passageiros</th>
        <td mat-cell *matCellDef="let item" [class.cancelado]="cancelado(item)">
          @for (pax of passageiros(item); track $index) {
          <div>{{ pax.nome }}@if (pax.contato) { <span class="text-gray-500"> — {{ pax.contato }}</span> }</div>
          } @empty {
          -
          }
        </td>
      </ng-container>

      <ng-container matColumnDef="veiculo">
        <th mat-header-cell *matHeaderCellDef>Veículo</th>
        <td mat-cell *matCellDef="let item" [class.cancelado]="cancelado(item)">
          {{ item.veiculo || '-' }}<br />{{ item.placa || '-' }}
        </td>
      </ng-container>

      <ng-container matColumnDef="fornecedor">
        <th mat-header-cell *matHeaderCellDef>Fornecedor</th>
        <td mat-cell *matCellDef="let item" [class.cancelado]="cancelado(item)">{{ item.fornecedor || '-' }}</td>
      </ng-container>

      <ng-container matColumnDef="status">
        <th mat-header-cell *matHeaderCellDef>Status</th>
        <td mat-cell *matCellDef="let item">{{ rotuloStatusEscala(item.descricaoStatus) || '-' }}</td>
      </ng-container>

      <tr mat-header-row class="style-header" *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row class="style-row" *matRowDef="let row; columns: displayedColumns"></tr>
    </table>
  </div>
  }
  }
</div>
